import { useRef } from "react";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

interface FinalCTAProps {
  onContactUs: () => void;
}

export function FinalCTA({ onContactUs }: FinalCTAProps) {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: "h3, p, .contact-us-button", stagger: 0.15 });

  return (
    <section
      ref={sectionRef}
      id="section-eleven"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding left-section-padding">
        <div className="eleventh-section">
          <div className="section-masthead__heading">
            <h3 className="h3 mt-0 mb-0">CONTACT US</h3>
            <p>Learn more about the product, the subscription plans, or schedule a demo.</p>
            <button className="contact-us-button contactus-button" onClick={onContactUs}>
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
